import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'
import { StickyControlled } from '@mc/design-system'

import { CSR } from 'components/CSR/CSR'

import { FloatingAction } from './FloatingAction'
import { useConciergeExperience } from '../hooks'
import { FabProvider, useFab } from './FabProvider'
import { CONCIERGE_EXPERIENCE_FLAG_NAME } from '../constants'

// This FAB v2 should be displayed if:
// * User in on any variant of the experiment
// * User is on any page that has the sticky footer
// * User is not at the top of the page or User is not at the bottom of the page
export const ConciergeExperienceExperiment = () => {
  const { isVariant } = useConciergeExperience()

  useEffect(() => {
    trackExperimentViewed(CONCIERGE_EXPERIENCE_FLAG_NAME)
  }, [])

  if (!isVariant) return null

  return (
    <CSR>
      <FabProvider>
        <FloatingContent />
      </FabProvider>
    </CSR>
  )
}

const DEFAULT_STICKY_FOOTER_OFFSET_DESKTOP = 98
const DEFAULT_STICKY_FOOTER_OFFSET_MOBILE = 110

const FloatingContent = () => {
  const { isFabVisible } = useFab()

  const stickyFooterHeight =
    document.getElementById('sticky-footer')?.offsetHeight || 0
  const stickyFooterOffset = stickyFooterHeight + 22

  return (
    <div data-testid='floating-content'>
      <div className='d-block d-md-none'>
        <StickyControlled
          offset={stickyFooterOffset ?? DEFAULT_STICKY_FOOTER_OFFSET_MOBILE}
          className='mc-bg-transparent'
          show={isFabVisible}
        >
          <FloatingAction />
        </StickyControlled>
      </div>

      <div className='d-none d-md-block'>
        <StickyControlled
          offset={stickyFooterOffset ?? DEFAULT_STICKY_FOOTER_OFFSET_DESKTOP}
          className='mc-bg-transparent'
          show={isFabVisible}
        >
          <FloatingAction />
        </StickyControlled>
      </div>
    </div>
  )
}
